import ScheduledMeetingActions from "./ScheduledMeetingActions";
import React, { useEffect, useState } from "react";
import { Alert, Box, ButtonBase, CircularProgress, Typography } from "@mui/material";
import InterviewCalendar from "./InterviewCalendar";
import { INTERVIEWS_CHANGED, loadInterviews, openInterviewScheduler } from "../utils/interviewScheduling";

export default function TodayAgenda() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true, requestId = 0;
    const load = async () => {
      const id = ++requestId;
      const from = new Date(); from.setHours(0, 0, 0, 0);
      const to = new Date(from); to.setDate(to.getDate() + 1);
      try {
        const data = await loadInterviews({ scope: "all", from: from.toISOString(), to: to.toISOString(), includeDiscovery: true });
        if (!active || id !== requestId) return;
        setRecords((data.interviews || []).filter(record => {
          const start = new Date(record.starts_at), end = new Date(record.ends_at);
          return record.interview_status !== "cancelled" && start < to && end > from;
        }).sort((a, b) => new Date(a.starts_at) - new Date(b.starts_at)));
        setError("");
      } catch (err) { if (active && id === requestId) setError(err.message); }
      finally { if (active && id === requestId) setLoading(false); }
    };
    load();
    window.addEventListener(INTERVIEWS_CHANGED, load);
    const timer = window.setInterval(() => { if (!document.hidden) load(); }, 20000);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener(INTERVIEWS_CHANGED, load); };
  }, []);
  const time = value => new Date(value).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  return <>
    {loading && <CircularProgress size={20} aria-label="Loading agenda" />}
    {error && <Alert severity="error">{error}</Alert>}
    {!loading && !error && !records.length && <Typography fontSize={13} color="text.secondary">No interviews scheduled for today.</Typography>}
    <Box sx={{ maxHeight: 360, overflowY: "auto" }}>
      {records.map(record => <Box key={record.id} sx={{ mb: 1 }}><ButtonBase onClick={() => openInterviewScheduler({ candidateId: record.candidate_id, jobId: record.job_id, leadId: record.lead_id, kind: record.review_kind === "discovery_call" ? "discovery" : "interview", interviewId: record.id })}
        sx={{ width: "100%", display: "grid", gridTemplateColumns: "72px minmax(0, 1fr)", gap: 1, textAlign: "left", alignItems: "start", p: 1, color: "primary.main", borderRadius: 1, "&:hover": { bgcolor: "action.hover" }, "&.Mui-focusVisible": { outline: "2px solid", outlineColor: "primary.main", outlineOffset: -2 } }}>
        <Box><Typography fontSize={12} fontWeight={700}>{time(record.starts_at)}</Typography><Typography fontSize={11} color="text.secondary">{time(record.ends_at)}</Typography></Box>
        <Box sx={{ minWidth: 0, overflowWrap: "anywhere" }}><Typography fontSize={12.5} fontWeight={700} color="text.primary">{record.event_title || record.candidate_name || "Interview"}</Typography><Typography fontSize={11.5} color="text.secondary">{[record.company_name, record.contact_name].filter(Boolean).join(" - ")}</Typography></Box>
      </ButtonBase><Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, px: 0.5, mt: 0.5 }}><ScheduledMeetingActions record={record} /></Box></Box>)}
    </Box>
    <Box textAlign="center" mt={1}><InterviewCalendar buttonLabel="View full calendar" /></Box>
  </>;
}
